import { api } from '@common';
import { CardForm, Divisor, WrapperPage } from '@components/atoms';
import { FormAddress, FormPersonalData, PageHeader } from '@components/molecules';
import { Button, Form, message, Select } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
interface SubmitCustomerInterface {
  family: {
    birthday: string;
    email: string;
    gender: string;
    maritalStatus: string;
    monthlyIncome: string;
    name: string;
    nationality: string;
    phone: string;
    profession: string;
    propertyRegime: string;
  };
  cep?: string;
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
}

export const CustomerNew = () => {
  const [form] = Form.useForm();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const onChangeCep = (cep: any) => {
    form.setFieldsValue({
      street: cep.logradouro,
      neighborhood: cep.bairro,
      city: cep.localidade,
      state: cep.uf,
    });
  };

  const handleSubmit = async (data: SubmitCustomerInterface) => {
    try {
      setIsSubmitting(true);
      const dataSubmit = {
        ...data,
        family: {
          ...data.family,
          birthday: dayjs(data.family.birthday).format('YYYY-MM-DD')
        },
        address: {
          cep: data.cep,
          street: data.street,
          number: data.number,
          complement: data.complement,
          neighborhood: data.neighborhood,
          city: data.city,
          state: data.state
        }
      };

      await api.post('/customer', dataSubmit).then((res) => {
        if (res.data.id) {
          message.success('Cliente adicionado com sucesso');
          navigate(`/clientes/${res.data.id}`);
        } else {
          message.error('Erro ao adicionar cliente');
        }
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response && error.response.data?.message) {
          message.error(error.response.data.message, 4);
        } else if (error.response) {
          message.error(`Erro ${error.response.status}: ${error.response.statusText}`);
        } else {
          message.error('Erro ao adicionar cliente');
        }
      } else {
        message.error('Erro inesperado ao adicionar cliente');
      }
      console.error('Erro detalhado:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <WrapperPage>
      <PageHeader title="Adicionar cliente" />

      <Form
        size='large'
        onFinish={handleSubmit}
        layout='vertical'
        disabled={isSubmitting}
        form={form}
      >
        <CardForm>
          <div className='text-right text-xs text-zinc-400 mb-4'>
            *campos obrigatórios
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
            <Form.Item
              label='Escritório parceiro'
              name='officeId'
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            >
              <Select
                placeholder='Selecione um escritório'
                showSearch
                optionFilterProp='label'
                options={[]}
              />
            </Form.Item>

            <Form.Item
              label='Assessor responsável'
              name='advisorId'
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            >
              <Select
                placeholder='Digite o nome do assessor'
                showSearch
                optionFilterProp='label'
                options={[]}
              />
            </Form.Item>
          </div>

          <Divisor className='mb-6 mt-2' />
          <FormPersonalData prefix='family' />
          <Divisor className='mb-6 mt-2' />
          <FormAddress onChangeCep={onChangeCep} defaultMemberAddress={true} />
        </CardForm>

        <div className='px-4 md:px-0 text-right pt-6'>
          <Button className='w-full md:w-auto' type='primary' htmlType='submit' loading={isSubmitting}>
            Adicionar Cliente
          </Button>
        </div>
      </Form>
    </WrapperPage>
  );
};
